import React from "react";
import { Building, User, Briefcase, CheckCircle2 } from "lucide-react";

interface ProgressStepsProps {
  currentStep: number;
}

export const ProgressSteps = ({ currentStep }: ProgressStepsProps) => {
  const steps = [
    { id: 1, name: "Company Details", icon: Building },
    { id: 2, name: "Contact & Location", icon: User },
    // { id: 3, name: "Projects", icon: Briefcase },
    // { id: 4, name: "Review", icon: CheckCircle2 },
  ];

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center">
              <div
                className={`h-10 w-10 rounded-full border-2 flex items-center justify-center ${
                  currentStep >= step.id ? "border-emerald-500 bg-emerald-50" : "border-gray-300"
                }`}
              >
                <step.icon
                  className={`h-5 w-5 ${currentStep >= step.id ? "text-emerald-500" : "text-gray-400"}`}
                />
              </div>
              <p
                className={`text-xs mt-1 ${
                  currentStep >= step.id ? "text-emerald-500 font-medium" : "text-gray-500"
                }`}
              >
                {step.name}
              </p>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-1 flex-1 mx-2 ${
                  currentStep > step.id ? "bg-emerald-500" : "bg-gray-200"
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};